import { CommonModule } from '@angular/common';
import { Component, OnInit, signal, TemplateRef, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { STORAGE_KEYS } from 'countable@helpers';
import { SharedModule } from 'src/app/components/shared/shared.module';
import { CoreModule } from 'src/app/core/core.module';
import { PlaidEngagementDetails, PlaidInstitution, Slides, PlaidDisconnectBank, SlideMessages } from 'src/app/model/plaid.model';
import { PlaidService } from 'src/app/services/plaid.service';

@Component({
  selector: 'app-firm-link-banking',
  templateUrl: './firm-link-banking.component.html',
  styleUrls: ['./firm-link-banking.component.scss'],
  imports: [CommonModule, SharedModule, CoreModule],
  encapsulation: ViewEncapsulation.None,
  standalone: true
})
export class FirmLinkBankingComponent implements OnInit {

  public readonly SK: typeof STORAGE_KEYS = STORAGE_KEYS;
  public bankingData: WritableSignal<PlaidInstitution[]> = signal<PlaidInstitution[]>(null);
  clientInformation: PlaidEngagementDetails;
  public invalidLink: WritableSignal<boolean> = signal<boolean>(false);
  isConfirmEnabled: WritableSignal<boolean> = signal<boolean>(false);
  @ViewChild("disconnectBanking") disconnectBanking: TemplateRef<any>;
  @ViewChild("unlinkBanking") unlinkBanking: TemplateRef<any>;
  deactivateCtrl: FormControl<string> = new FormControl<string>('');
  public deactivateInfo: WritableSignal<boolean> = signal<boolean>(false);
  clientKey: string = "";
  logoCache: { [key: string]: string } = {};

  constructor(private plaidService: PlaidService, private _avRoute: ActivatedRoute, 
     private dialog: MatDialog,) { 
      this.deactivateCtrl.valueChanges.subscribe({
        next: res => {
          this.checkDeactivate(res);
        }
      });
    }
    
  ngOnInit(): void {
    if (this._avRoute.snapshot.params["clientKey"]) {
      this.clientKey = this._avRoute.snapshot.params["clientKey"];
    }

    this.getClientDetails();
    this.fetchBankingLinks();
  }

  fetchBankingLinks() {
    this.plaidService.fetchAccounts(this.clientKey).subscribe({
      next: response => {
        if (response?.status === 200) {
          this.bankingData.set(response?.data);
          this.invalidLink.set(false);
          this.bankingData().forEach((institution) => {
            this.plaidService.getBankLogoClientSite(institution.institutionId).subscribe((res) => {
              if (res?.status === 200) {
                this.logoCache[institution.institutionId] = `data:image/png;base64,${res.data}`;
              } else {
                this.logoCache[institution.institutionId] = '/assets/images/ui-uplift-icons/global/payment-cards/common-bank-icon.svg';
              }
            });
          });

        } else {
          this.invalidLink.set(true);
        }
      }
    });
  }

  getClientDetails() {
    this.plaidService.getClientSideDetails(this.clientKey).subscribe(response => {
      if (response?.status === 200 && response?.data) {
        this.clientInformation = response.data;
      } else { 
        this.invalidLink.set(true);
      }
    });
  }



  disconnectBankingModel(){
    const dialogRef = this.dialog.open(this.disconnectBanking, {});
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {        
        this.disconnectBankingLink();
      } else {
        this.isConfirmEnabled.set(false);
        this.deactivateCtrl.reset();
      }
    });
  }

  enableConfirm() {
    this.isConfirmEnabled.set(true);
  }

  private checkDeactivate(typedText: string = '') {
    this.deactivateInfo.set(typedText?.toLocaleLowerCase() === 'disconnect');
  }

  disconnectBankingLink() {
    this.plaidService.plaidDisconnectEngClientSite({
      engagementId: this.clientInformation.engagementId,
      clientId: this.clientInformation.clientId,
      firmId: this.clientInformation.firmId
    }).subscribe({
      next: response => {
        if (response?.status === 200) {
          localStorage.setItem('firmDisconnectAll', 'true');
          this.closeNewWindow();
        }
      }
    });
  }

  getCachedLogo(institutionId: string): string {
    return this.logoCache[institutionId] || '';
  }

  closeNewWindow() {
    window.opener = self;
    window.close();
  }

}
